// Ko'rsatish uchun formatlash: sana, vaqt, telefon, pul. Barcha ilovalar uchun bir xil.

const pad = (n: number) => String(n).padStart(2, '0');

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${fmtDate(iso)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "5 daqiqa oldin", "kecha", "3 kun oldin" */
export function fmtAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return 'hech qachon';
  const diff = Math.round((now - new Date(iso).getTime()) / 1000);
  if (diff < 60) return 'hozirgina';
  if (diff < 3600) return `${Math.floor(diff / 60)} daqiqa oldin`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} soat oldin`;
  const days = Math.floor(diff / 86400);
  if (days === 1) return 'kecha';
  if (days < 30) return `${days} kun oldin`;
  return fmtDate(iso);
}

/** Muddat tugashiga necha kun qoldi (manfiy — o'tib ketgan) */
export function daysLeft(iso: string | null | undefined, now = Date.now()): number | null {
  if (!iso) return null;
  return Math.ceil((new Date(iso).getTime() - now) / 86_400_000);
}

export function fmtDaysLeft(iso: string | null | undefined): string {
  const d = daysLeft(iso);
  if (d === null) return '—';
  if (d < 0) return `${-d} kun o‘tdi`;
  if (d === 0) return 'bugun tugaydi';
  return `${d} kun qoldi`;
}

/** "+998901234567" -> "+998 90 123 45 67" */
export function fmtPhone(phone: string | null | undefined): string {
  if (!phone) return '—';
  const m = phone.replace(/\D/g, '').match(/^998(\d{2})(\d{3})(\d{2})(\d{2})$/);
  return m ? `+998 ${m[1]} ${m[2]} ${m[3]} ${m[4]}` : phone;
}

/** 1250000 -> "1 250 000" */
export function fmtNumber(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  const [int, frac] = String(Math.round(n * 1000) / 1000).split('.');
  const grouped = (int ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return frac ? `${grouped},${frac}` : grouped;
}

export function fmtMoney(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return `${fmtNumber(Math.round(n))} so‘m`;
}

/** Katta summalar qisqa: 61 250 000 -> "61,3 mln so‘m" */
export function fmtMoneyShort(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  const abs = Math.abs(n);
  const one = (v: number) => v.toFixed(1).replace(/\.0$/, '').replace('.', ',');
  if (abs >= 1e9) return `${one(n / 1e9)} mlrd so‘m`;
  if (abs >= 1e6) return `${one(n / 1e6)} mln so‘m`;
  return fmtMoney(n);
}

/** "45 000" yoki "45000" -> 45000 (noto'g'ri bo'lsa null) */
export function parseAmount(text: string): number | null {
  const clean = text.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(clean)) return null;
  return Number(clean);
}

export function initials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}
